import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=2e4905b1&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=ts"
export * from "./ChartCard.vue?vue&type=script&lang=ts"
import style0 from "./ChartCard.vue?vue&type=style&index=0&id=2e4905b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4905b1",
  null
  
)

export default component.exports